angular.module('rjmNg.api').factory("Metrics", [
  "$cacheFactory"
  "$http"
  "$q"
  "$resource"
  "appRoute"
  "FilterSets"
  "encodedLetterString"
  "metricEnums"
  "phpServiceUrl"
  "serviceUrl"
  "stringService"
  "StructureCache"
  (
    $cacheFactory
    $http
    $q
    $resource
    appRoute
    FilterSets
    encodedLetterString
    metricEnums
    phpServiceUrl
    serviceUrl
    stringService
    StructureCache
  ) ->
    _aggFns = _.reduce(metricEnums.AGGREGATE_FUNCTIONS_IDS, (accu, id, key) -> 
          accu[key] = {
            id: id
            name: metricEnums.AGGREGATE_FUNCTIONS[key] || ''
            code: key
          }
          return accu
        , {})

    Metrics = $resource(phpServiceUrl("/client/:clientId/metric/:id"), {}
        dependents:
          method: 'GET'
          cache: $cacheFactory.get('Metrics.dependents') or $cacheFactory('Metrics.dependents')
          url: phpServiceUrl("/client/:clientId/metric/:id/dependents/")
        update:
          method: 'PUT'
        create:
          method: 'POST'
        get:
          cache: $cacheFactory.get('Metrics.get') or $cacheFactory('Metrics.get')
        getAll:
          isArray: true
          cache: $cacheFactory.get('Metrics.getAll') or $cacheFactory('Metrics.getAll')
          url: serviceUrl("/clients/:clientId/metrics")
          headers:
            Accept: 'application/json'
            'Content-Type': 'application/json'
          withCredentials: true
        query:
          isArray: true
          cache: $cacheFactory.get('Metrics.query') or $cacheFactory('Metrics.query')
          
    )

    generateBaseMetric = (table, metrics) ->
      # Build the name
      existingNames = (metric.name for metric in metrics)
      name = stringService.getUniqueString(existingNames, "New Metric")


      # Get primary key and timestamp column guesses
      pk = (column for column in table.columns when column.is_primary_key == true)[0]
      ts = (column for column in table.columns when column.field_type == "datetime")[0]

      # Build the dimensions
      dimensions = []
      dimensions.push {
        'column_id': column.id,
        'is_groupable': guessGroupable(column)
        } for column in table.columns

      # Build the base metric
      metric =
        "operation_column_id": pk?.id ? table.columns[0].id,
        "timestamp_column_id": ts?.id ? null,
        "subscription_column_id": null,
        "subscription_start_column_id": null,
        "subscription_end_column_id": null,
        "name": name,
        "command": "COUNT_DISTINCT",
        "table_id": table.id,
        "dimensions": dimensions,
        "filters": [
        ],
        "sequence": ""

      return metric

    guessGroupable = (column) ->
      if column.field_type == "description" then return false
      if column.field_type == "datetime" then return false
      values = [
        "value_general",
        "value_bytes",
        "value_seconds",
        "value_percentage",
        "value_currency",
        "value_raw"
      ]
      if column.field_type in values
        if column.properties?.derivative_type == "sequence"
          return true
        if column.properties?.derivative_type == "aggregate"
          if column.properties?.aggregate_operation == "count" or
          column.properties?.aggregate_operation == "count_distinct"
            return true
        return false
      return true

    getCalcTypeByCol = (col, table, colMap) ->
      operationOptions = [_aggFns.COUNT_DISTINCT]
      if(col.is_primary_key)
        operationOptions.push(_aggFns.COUNT)
        if(table.hasSubscription)
          operationOptions.push.apply(operationOptions,[
            _aggFns.SUB_COUNT
            _aggFns.SUB_COUNT_DISTINCT
          ])

      if(col.reference_column_id && colMap[col.reference_column_id].table_id)
        if(table.hasSubscription)
          operationOptions.push.apply(operationOptions,[
            _aggFns.SUB_COUNT
            _aggFns.SUB_COUNT_DISTINCT
          ])

      if(_isValue(col.field_type))
        operationOptions.push.apply(operationOptions, [
          _aggFns.SUM
          _aggFns.AVERAGE
          _aggFns.MEDIAN
          _aggFns.FIRST_QUARTILE
          _aggFns.THIRD_QUARTILE
          _aggFns.TENTH_PERCENTILE
          _aggFns.NINETIETH_PERCENTILE
          _aggFns.MAX
          _aggFns.MIN
        ])
        if(table.hasSubscription)
          operationOptions = _.union(operationOptions,[
            _aggFns.SUB_COUNT
            _aggFns.SUB_COUNT_DISTINCT
            _aggFns.SUB_SUM
            _aggFns.SUB_AVERAGE
          ])

      if(col.field_type is 'datetime')
        operationOptions.push.apply(operationOptions, [
          _aggFns.MAX
          _aggFns.MIN
        ])
      
      if((col.field_type is 'flag' || col.field_type is 'email') && table.hasSubscription)
        operationOptions = _.union(operationOptions,[
            _aggFns.SUB_COUNT
            _aggFns.SUB_COUNT_DISTINCT
          ])

      return operationOptions

    _isValue = (ft) ->
          return _.contains(['value_general', 'value_bytes', 'value_seconds', 'value_percentage', 'value_currency', 'value_raw'], ft)

    buildTableHasMetricMap = (tables, metrics) ->
      tableHasMetric = {}
      tableHasMetric[table.id] = false for table in tables
      tableHasMetric[metric.table_id]  = true for metric in metrics
      return tableHasMetric

    get = (clientId, id = null) ->
      if id?
        return Metrics.get({clientId, id}).$promise

      Metrics.query({clientId}).$promise

    getAll = (clientId, reportUsage = false) -> #reoprtUsage is optional
      Metrics.getAll({ 'clientId' : clientId, 'report-usage': reportUsage}).$promise

    update = (clientId, id, metric) ->
      $cacheFactory.get('Metrics.get')?.remove(phpServiceUrl("/client/#{clientId}/metric/#{id}"))
      $cacheFactory.get('Metrics.getAll')?.removeAll()
      Metrics.update({clientId, id}, metric).$promise

    deleteMetric = (clientId, id) ->
      $cacheFactory.get('Metrics.query')?.removeAll()
      $cacheFactory.get('Metrics.getAll')?.removeAll()
      Metrics.delete({clientId, id}).$promise

    dependents = (clientId, id, force = false) ->
      if(force)
        $cacheFactory.get('Metrics.dependents')?.remove(phpServiceUrl("/client/#{clientId}/metric/#{id}/dependents"))
      Metrics.dependents({clientId, id}).$promise

    create = (clientId, metric) ->
      $cacheFactory.get('Metrics.query')?.removeAll()
      $cacheFactory.get('Metrics.getAll')?.removeAll()
      Metrics.create({clientId}, metric).$promise

    setUserRights = (clientId, id, userId, access) ->
      $http(
        {
        method: 'POST'
        url: phpServiceUrl("/client/#{clientId}/trend/#{id}/userRights/")
        withCredentials: true
        data: 'uid=' + userId + '&set=' + if access then 1 else 0 + '&batch=0'
        headers:
          'Accept': 'application/json'
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      })



    getFullMetricInfo = (clientId, id) ->
      $q((resolve,reject) ->
        $q.all([
          Metrics.get({ clientId, id }).$promise
          FilterSets.get(clientId)
          StructureCache.getStructure()
        ]).then((successResponse) ->
          [fullMetric, filterList, structureInfo] = successResponse
          tableMap = angular.copy(structureInfo.tables)
          colMap = angular.copy(structureInfo.columns)
          tempFilterList = angular.copy(filterList)
          tempMetric = angular.copy(fullMetric)
          _configureMetric(tempMetric, tempFilterList, tableMap, colMap)

          resolve(tempMetric)
        , (errorResponse) ->
          console.log(errorResponse)
          reject(errorResponse)
        )
      )
    
    #Dimension order and deactivated dimensions matter because the index is used in old cohort charts
    #Use this function to preserve original order and values, while UI only needs to worry about actual dimensions
    #ogDimensions should be direct copy of dimensions from Metric.get response
    #newDimensions should be all active dimensions needed to be sent back for update
    resolveDimensions = (ogDimensions, newDimensions) ->
      ogDims = angular.copy(ogDimensions)
      newDims = angular.copy(newDimensions)
      ogActiveDims = _.filter(ogDims, (og) -> return og.column_id)
      dimsToAdd = _.filter(newDims, (nd) -> return !_.find(ogActiveDims, (og) -> og.column_id is nd.column_id ))
      resultDims = ogDims.concat(dimsToAdd)
      resultDims = resultDims.map((rd) ->
                    inNew = _.find(newDims, (nd) -> return nd.column_id is rd.column_id)
                    if(inNew)
                      rd = inNew
                    else
                      rd = {column_id: null, is_groupable: false}
                    rd)
      return resultDims

    swapDimension = (clientId, metricId, ogId, newId, swapAll, grouped) ->
      $cacheFactory.get('Metrics.query')?.removeAll()
      $cacheFactory.get('Metrics.getAll')?.removeAll()
      if(swapAll)
        $cacheFactory.get('Metrics.get')?.removeAll()
      else
        $cacheFactory.get('Metrics.get')?.remove(phpServiceUrl("/client/#{clientId}/metric/#{metricId}"))
      $http(
        {
        method: 'POST'
        url: phpServiceUrl("/client/#{clientId}/trend/#{metricId}/swapSlicer")
        withCredentials: true
        data: 'slicerName=swapslicer_' + ogId + '&sid=' + newId + '&global=' + (if swapAll then 1 else 0) + '&grouped=' + (if grouped then 1 else 0)
        headers:
          'Accept': 'application/json'
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

      })

    _addDimensionDetails = (metric, columnsMap) ->
      metric.dimensions?.map((dim) ->
        dim.column = columnsMap[dim.column_id]
      )

    _addSpecialColumnDetails = (metric, columnsMap) ->
      if(metric.timestamp_column_id?)
        metric.timestamp_column = columnsMap[metric.timestamp_column_id]
      if(metric.operation_column_id?)
        metric.operation = metricEnums.AGGREGATE_FUNCTIONS[metric.command]
        metric.operation_column = columnsMap[metric.operation_column_id]

    _addFilterDetails = (metric, filters, columnsMap) ->
      filterMap = _toMap(filters)
      for fil, ix in metric.filters
        fil.identifier = encodedLetterString.indexToAlpha(ix)
        fil.linkUrl = ''
        if(fil.filter_set_id?)
          fil.filter_set = filterMap[fil.filter_set_id]
          fil.name = filterMap[fil.filter_set_id].name
          fil.linkUrl = appRoute('/settings/filter-set/' + fil.filter_set_id)
        else
          if(fil.left?.column_id? and fil.operation? and fil.right?)
            dispVal = '' 
            if(fil.right.value is null)
              dispVal = '[NULL]' 
            else 
              dispVal = fil.right.value
            fil.name = columnsMap[fil.left.column_id].name + ' ' + fil.operation + ' ' + dispVal

    _addTableDetails = (metric, tables) ->
      metric.table = tables[metric.table_id]

    _configureMetric = (fullMetric, filterList, tableMap, columnMap) ->
      _addDimensionDetails(fullMetric, columnMap)
      _addFilterDetails(fullMetric, filterList, columnMap)
      _addTableDetails(fullMetric, tableMap)
      _addSpecialColumnDetails(fullMetric, columnMap)


    _toMap = (list) -> _.object(list.map((item) -> [item.id, item]))

    {
      get: get
      getAll: getAll
      getCalcTypeByCol: getCalcTypeByCol
      getFullMetricInfo: getFullMetricInfo
      update: update
      delete: deleteMetric
      dependents: dependents
      create: create
      generateBaseMetric: generateBaseMetric
      guessGroupable: guessGroupable
      buildTableHasMetricMap: buildTableHasMetricMap
      resolveDimensions: resolveDimensions
      setUserRights: setUserRights
      swapDimension: swapDimension
    }
  ]
)
